<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Envio de Mail a Clientes
      <span v-if="checkedUsers.length" class="text-sm font-medium text-gray-600 dark:text-gray-400">({{ checkedUsers.length }} seleccionados)</span>
      </h1>    
    <div class="bg-white rounded-md shadow overflow-hidden" >
        <div class="px-4  text-sm py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <!-- <label class="p-0 pt-2 pb-2 block" for="">Usuarios: <input type="checkbox" class="form-checkbox"  v-model="selectAll"><small class="ml-2">Seleccionar todos</small> </label> -->

          <label class="ml-auto" for="">Esconder usuarios sin Propiedades:  <input type="checkbox" class="form-checkbox -mb-1"  v-model="removeInactive"></label> 
        </div>
      <!-- {{removeInactive}} -->
      <!--  -->
      <div class="overflow-scroll border-double adv		border  border-gray-100 h-96">
        <table class="table-auto table w-full whitespace-nowrap">
        <thead>
          <tr class="text-left">
            <th class="p-4">Usuario</th>
            <th class="p-4">Email</th>
            <th class="p-4">Cantidad de Propiedades</th>
            <th class="p-4">Temporada 2026</th>
            <th class="p-4">Temporada 2027</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="ad in advertisers" :key="ad.ID" class="text-sm"   >
          <td class="px-4 py-2  border-t" v-if="ad.properties_count || !removeInactive" > 
            <input type="checkbox" class="form-checkbox" v-model="checkedUsers" :value="ad.correo" :disabled="(!validateEmail(ad.correo)) ? true : false">

            {{ ad.usuario}}
          
        </td>
          <td class="px-4 py-2  border-t" v-if="ad.properties_count || !removeInactive" >
              {{ ad.correo}}
             </td>
          <td class="px-4 py-2  border-t" v-if="ad.properties_count || !removeInactive" > 
            <span v-if="ad.properties_count && (ad.deactivated - ad.properties_count == 0)"  class="bg-red-500 text-center text-white  inline-block px-4 rounded-full "> Desactivado por Admin ({{ ad.deactivated }}/{{ ad.properties_count }})</span>
            <span v-if="ad.properties_count - ad.deactivated > 0" :class="ad.properties_count ? 'bg-green-500' : 'bg-red-500'"  class="w-8 h-8 ml-2 pt-2 text-center text-white  block rounded-full">{{ ad.properties_count}}</span>

            <div :class="(!ad.correo) ? 'text-red-500' : ''" class=""> {{!validateEmail(ad.correo) ? 'Errores en el mail' : ''}}</div>
          </td>
          
          <td class="px-4 py-2  border-t" v-if="ad.properties_count || !removeInactive" > 
            <div class="flex">
              <span :class="ad.sindeudas26 ? 'bg-green-500' : 'bg-red-500'"  class=" ml-2  text-center text-white  inline-block px-4 rounded-full">{{ ad.sindeudas26 ? 'Pago' : 'Deuda'}}</span>
            <inertia-link class="px-4 flex items-center" :href="route('advertisers.edit', ad.ID)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
            </div>
            
          </td>
          <td class="px-4 py-2  border-t" v-if="ad.properties_count || !removeInactive" > 
            <div class="flex">
              <span :class="ad.sindeudas27 ? 'bg-green-500' : 'bg-red-500'"  class=" ml-2  text-center text-white  inline-block px-4 rounded-full">{{ ad.sindeudas27 ? 'Pago' : 'Deuda'}}</span>
            </div>
          </td>
        </tr>
      </tbody>
        </table>
       
      </div>

      
       <form @submit.prevent="sendEmail">
        <div class="p-8 -mr-6 -mb-8 flex flex-col">
            <!-- Show checkedUsers list on badge -->
            <div class="flex flex-wrap mb-4">
              <label class="mb-2 block" for="">Emails:</label>
              <span v-for="user in checkedUsers" :key="user" class="bg-gray-100 text-gray-800 text-xs font-semibold m-2 mt-0 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300">
                {{ user }}
              </span>
              </div>

            <!-- {{ checkedUsers}} -->
            <text-input v-model="form.asunto" :error="form.errors.asunto" class="pr-6 pb-8 w-full lg:w-1/2" label="Asunto" />
            <div class="pb-8">
              <label class="mb-2 block" for="">Contenido del mail:</label>
              <vue-editor class="w-full" v-model="form.content"  :editor-toolbar="customToolbar"  />
            </div>
          
        </div>
         <div class="px-8 mt-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Enviar email a Clientes</loading-button>
        </div>
       </form>
       
    </div>
   
    

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { VueEditor } from "vue2-editor";
import LoadingButton from "@/Shared/LoadingButton";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import Icon from '@/Shared/Icon'


export default {
  metaInfo: { title: 'Mail a Usuarios' },
  layout: Layout,
  components: {
    VueEditor,
    TextInput,
    SelectInput,
    LoadingButton,
    Icon
  },
  props: {
    filters: Object,
    advertisers: Array,

  },
   watch: {
    selectAll: {
      handler (tempValues) {
        this.checkedUsers = [];
        if(tempValues) {
            document.querySelectorAll('.adv .form-checkbox').forEach(function(el){
            el.click()

            });
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      content: '',
      filter: '',
      checkedUsers:[],
      selectAll: false,
      removeInactive: false,
      customToolbar: [
      [{ header: [false, 2] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        ["link"],
        ["clean"] // remove formatting button,
      ], 
      form: this.$inertia.form({
        asunto: '',
        content: '',

      }),
      
    }
    
  },
  methods: {
    validateEmail(email) {
      // console.log(email);
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return true;
        } else {
           return false;
        }
    },
    sendEmail() {
      let arr = this.checkedUsers;
      const unique = Array.from(new Set(arr));
      console.log(unique.length);
      this.form
        .transform((data) => ({
            ...data,
          users: unique,
        }))
        .post(this.route("sendmail"), {
          onSuccess: (page) => {
            this.form.asunto = '';
            this.form.content = '';
            this.checkedUsers = [];
            // _this.pictures = page.props.photos.map((data, index) => {
            //   return { ...data, intOrder: index + 1 };
            // });
            // console.log(page, imageId);
          },
          onError: (error) => {
            console.log(error);
          },
        });
      
    },
      },
}
</script>
